/**
 * <Footer />
 *
 * @parent Modal
 * @stateless
 *
 * this is how you declare a button for footer:
		[{
			title: "升级高级版",
			className: "btn btn-primary pull-right",
			onClick: ()=>{
				console.log("hello!");
			}
		},]
 *
 * */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { Button } from "components/UI"

const DEFAULT_FOOTER_TYPE = "grey";

class Footer extends React.Component {
  constructor(props) {
		super(props);
	}

	render() {
		let {
			footerClassName,
			footerButtons,
			footerType,
			footerCustomContent,
		} = this.props;
    return (
			<div className={classnames("footer", footerClassName, "type-" + (footerType || DEFAULT_FOOTER_TYPE))}>
				{ footerCustomContent && <div className='footer-custom-content'>{footerCustomContent}</div> }
				{ footerButtons && footerButtons.length > 0 && <div className='button-wrapper'>{this._renderButtons()}</div> }
      </div>
    );
	}

		_renderButtons() {
			let {
				footerButtons,
			} = this.props;
			return footerButtons.map((btn, idx)=>{
				let {
					title,
					className,
          isDisabled,
				} = btn;

        let disabled
        if(typeof(isDisabled) == 'function'){
          disabled = isDisabled(this.props)
        } else {
          disabled = isDisabled;
        }
				return (<Button key={idx} bsClass={className} disabled={disabled} onClick={btn.onClick}>{title}</Button>);
			});
		}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Footer.js